<template>
  <div class="gallery">
    <div class="mb-5 level">
      <h3>Galería del producto</h3>
      <b-tooltip label="Agregar">
        <b-button
          type="is-dark"
          size="is-small"
          @click="modalGalleryAdd = true"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
        </b-button>
      </b-tooltip>
    </div>
    <hr />
    <b-table
      :data="data"
      detail-key="id"
      icon-pack="fas"
    >
      <b-table-column field="name" label="Media" v-slot="props">
        <img
          v-if="props.row.gallery_type === 'IMAGE'"
          :src="props.row.image"
          style="max-width: 100px;"
        />
        <img
          v-else
          :src="`https://img.youtube.com/vi/${props.row.video.slice(-11)}/0.jpg`"
          style="max-width: 100px;"
        >
      </b-table-column>
      <b-table-column field="name" label="Tipo" v-slot="props">
        <span v-if="props.row.gallery_type === 'IMAGE'">Imagen</span>
        <span v-else>Video</span>
      </b-table-column>
      <b-table-column field="address" label="Posición" v-slot="props">
        <span>{{ props.row.position }}</span>
      </b-table-column>
      <b-table-column field="shipping_cost" label=""  v-slot="props">
        <div style="text-align: right">
          <b-button
            type="is-primary"
            size="is-small"
            @click="openModalEdit(props.row.id)"
          >
            <font-awesome-icon :icon="['fas', 'edit']" />
          </b-button>
          <b-button
            type="is-danger"
            size="is-small"
            class="ml-1"
            @click="openModalDelete(props.row.id)"
          >
            <font-awesome-icon :icon="['fas', 'trash']" />
          </b-button>
        </div>
      </b-table-column>
    </b-table>
    <ModalGalleryAdd
      v-if="modalGalleryAdd"
      @hidden="modalGalleryAdd = false"
      @reload="getInfo"
    />
    <ModalGalleryEdit
      v-if="modalGalleryEdit"
      @hidden="modalGalleryEdit = false"
      @reload="getInfo"
      :idGallery="idGallery"
    />
    <ModalGalleryDelete
      v-if="modalGalleryDelete"
      @hidden="modalGalleryDelete = false"
      @reload="getInfo"
      :idGallery=idGallery
    />
  </div>
</template>

<script>
import ProductService from '@/services/ProductService'
import ModalGalleryAdd from '@/components/product/ModalGalleryAdd'
import ModalGalleryEdit from '@/components/product/ModalGalleryEdit'
import ModalGalleryDelete from '@/components/product/ModalGalleryDelete'
export default {
  components: {
    ModalGalleryAdd,
    ModalGalleryEdit,
    ModalGalleryDelete
  },
  data() {
    return {
      data: [
        {
          id: '',
          gallery_type: '',
          image: '',
          video: '',
          position: '',
          product: ''
        }
      ],
      modalGalleryAdd: false,
      modalGalleryEdit: false,
      modalGalleryDelete: false,
      idGallery: 0
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      try {
        const response = await ProductService.getGallery(this.$route.params.id)
        this.data = response.data
      } catch (error) {
        console.log(error)
      }
    },
    openModalEdit(id) {
      this.idGallery = id
      this.modalGalleryEdit = true
    },
    openModalDelete(id) {
      this.idGallery = id
      this.modalGalleryDelete = true
    }
  }
}
</script>

<style lang="scss">
.gallery {
  &__item {
    display: flex;
    img {
      width: 50px;
    }
  }
}
</style>
